import React from 'react'
import { withScriptjs, GoogleMap, withGoogleMap, OverlayView, Polygon, TrafficLayer } from 'react-google-maps'
import styled from 'styled-components'
import _ from 'lodash'

import geolib from 'geolib'

import districts from '../../../config/district'
import utils from '../../../utils'

const PHNOM_PENH_COORDS = {
  lat: 11.571898,
  lng: 104.926976,
}

const MapNode = styled.div`
  min-height: 600px;
  height: 100%;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
`

const MapContainer = styled.div`
  height: 100%;
  border-bottom-left-radius: 10px;
  borderBottomRightRadius: 10px;
`

const MapView = withScriptjs(withGoogleMap(props => (
  <GoogleMap
    defaultZoom={13}
    ref={props.onMapMounted}
    {...props}
  />
)))


export default class Map extends React.PureComponent {
  fitToCoordinates = bounds => {
    this.mapViewRef.fitBounds(bounds)
  }

  onMapMount = ref => {
    const { onMapMount, onReady } = this.props

    this.mapViewRef = ref
    onMapMount(this)
    onReady()
  }

  getDistrictPolygon = coordinates => {
    return _.map(coordinates, coordinate => ({
      lat: coordinate[1],
      lng: coordinate[0],
    }))
  }

  getCenterPolygon = coordinates => {
    const allCoords = _.map(coordinates, coordinate => ({
      latitude: coordinate[1],
      longitude: coordinate[0],
    }))

    let centerCoord = geolib.getCenter(allCoords)

    centerCoord = {
      lat: Number(centerCoord.latitude),
      lng: Number(centerCoord.longitude),
    }

    return centerCoord
  }

  renderPolygon = () => {
    return _.map(districts, (district, index) => [
      <OverlayView
        key={`${index}-name`}
        position={this.getCenterPolygon(district.coordinates)}
        mapPaneName={OverlayView.FLOAT_PANE}
        getPixelPositionOffset={(width, height) => ({ x: -(width / 2), y: -(height / 2) })}
        zIndex={0}
      >
        <div
          style={{
            backgroundColor: district.color,
            borderRadius: 7,
            padding: 6,
            textAlign: 'center',
            textOverflow: 'ellipsis',
            fontSize: 14,
            fontWeight: 'bold',
            color: 'white',
          }}
        >
          {district.name}
        </div>
      </OverlayView>,
      <Polygon
        key={`${index}-polygon`}
        visible
        options={{
          strokeColor: district.color,
          fillColor: district.color,
          fillOpacity: 0.1,
          strokeWeight: 1,
        }}
        paths={this.getDistrictPolygon(district.coordinates)}
      />,
    ])
  }

  render() {
    const { children, trafficLayer, polygonLayer } = this.props

    return (
      <MapView
        onMapMounted={this.onMapMount}
        defaultCenter={PHNOM_PENH_COORDS}
        containerElement={<MapContainer />}
        mapElement={<MapNode />}
        loadingElement={<MapContainer />}
        googleMapURL={utils.constants.GOOGLE_MAP_URL}
      >
        {children}
        {polygonLayer && this.renderPolygon()}
        {trafficLayer && <TrafficLayer autoUpdate />}
      </MapView>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/mapView/components/MapView.js